// extracted by mini-css-extract-plugin
export default {"Card":"TransactionsStatsCard_Card__V07mu","Top":"TransactionsStatsCard_Top__T0Zaj","Bottom":"TransactionsStatsCard_Bottom__3awsl"};